import client from '@/clients/customer/api-client';
import instance from '@/clients/common/client';
import Qs from 'qs';
import { withCacheTTL } from '../common/with-cache-ttl';

export const fetchCheckoutData = (filter: object | null = null) =>
  client.get('/settings/checkout', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
  });

export const fetchCheckoutDataByOrderId = (orderId: number) =>
  client.get(`/settings/checkout?order_id=${orderId}`);

export const fetchSettings = (headers: any) =>
  instance.get('/v1/customer/app-setting', {
    headers,
  });

export const fetchCachedSettings = withCacheTTL(
  fetchSettings,
  '/v1/customer/app-setting'
);
